export function removeLineBreaks(value: string): string {
	return value.replace(/(\r\n|\n|\r)/gm, "");
}

// TAKEN FROM - https://github.com/janl/mustache.js/blob/master/mustache.js#L55
const htmlEntityMap: Record<string, string> = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	'"': "&quot;",
	"'": "&#39;",
	"/": "&#x2F;",
	"`": "&#x60;",
	"=": "&#x3D;",
};

export function escapeHtml(value: string): string {
	return String(value).replace(/[&<>"'`=/]/g, (s) => {
		return htmlEntityMap[s];
	});
}

export function safeHtmlString(value: string): string {
	return escapeHtml(removeLineBreaks(value));
}
